/**
 * Represents the pager details of a standard Search API REST response.
 */
export default class SearchApiResponsePager {
  constructor(currentPage, itemsPerPage, totalItems, totalPages) {
    this.current_page = currentPage;
    this.items_per_page = itemsPerPage;
    this.total_items = totalItems;
    this.total_pages = totalPages;
  }
}
